/** This file should not include supabase. */
import { invalidate } from '$app/navigation'
import { page } from '$app/state'
import type { View } from '$lib/supabase'

export let preloadedProfile: View<'profiles_with_stats'> | undefined

/**
 * If the user changed their profile locally, then you can call this function,
 * and invalidate supabase:auth. This will retrigger this load function, but not
 * require to load the profile data again.
 */
export const updateProfileLocally = (
  update: Partial<View<'profiles_with_stats'>>,
) => {
  const profile = page.data.session?.profile
  if (!profile) return
  preloadedProfile = { ...profile, ...update }
  invalidate('supabase:auth')
}
export const clearLocalProfile = () => (preloadedProfile = undefined)
export const reloadProfile = () => {
  invalidate('supabase:auth')
}
